import React from 'react';
import PropTypes from 'prop-types';
import { BackgroundImage, Image } from '$partials/media';
import Button from '$partials/ui/button';
import IconArrowRight from '$partials/icons/arrow-right';
import { useLocale } from '$contexts/locale.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleTestimonialItem = ({
    avatar,
    brandLogo = {},
    quote,
    credit,
    creditJobTitle,
    ctaLink,
    ctaLabel
}) => {
    const { formatURI } = useLocale();

    return (
        <>
            <div className='mx-10 sm:mx-5 md:mx-10 h-full'>
                <div className='px-30 pt-30 pb-[37px] md:px-50 md:pb-[47px] md:pt-50 rounded-button h-full flex flex-col justify-between bg-sand'>
                    <div className='flex flex-col'>
                        {brandLogo && (
                            <Image
                                className='object-contain object-left-top w-[140px] h-[28px] md:h-[36px]'
                                loading={''}
                                loadWidth={210}
                                src={brandLogo.src}
                                style={{ width: undefined }} />
                        )}
                        <p className='w-11/12 mt-60 md:mt-40 mb-10 md:mb-[12px] type-style-4'>
                            {quote}
                        </p>
                    </div>
                    <div className='flex flex-col'>
                        <div className='flex items-center'>
                            {avatar && (
                                <BackgroundImage
                                    containerClassName='relative w-[50px] h-[50px] bg-cover rounded-full mr-10 flex-shrink-0'
                                    loadWidth={150}
                                    src={avatar?.src}
                                    title={avatar?.title} />
                            )}
                            <div className='flex flex-col'>
                                {credit && (
                                    <p className='type-style-8 text-light-grey'>
                                        {credit}
                                    </p>
                                )}
                                {creditJobTitle && (
                                    <p className='type-style-8 text-light-grey'>
                                        {creditJobTitle}
                                    </p>
                                )}
                            </div>
                        </div>
                        {ctaLink && ctaLabel && (
                            <Button
                                as='a'
                                className='flex items-center type-style-7 mt-48'
                                href={formatURI(ctaLink)}
                                renderIcon={
                                    <IconArrowRight
                                        className='ml-10 h-[13px]'
                                        stroke='black' />
                                }>
                                {ctaLabel}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

ModuleTestimonialItem.propTypes = {
    avatar: PropTypes.object,
    brandLogo: PropTypes.shape({
        src: PropTypes.string
    }),
    quote: PropTypes.string,
    credit: PropTypes.string,
    creditJobTitle: PropTypes.string,
    ctaLink: PropTypes.string,
    ctaLabel: PropTypes.string,
};

export default ModuleTestimonialItem;
